<template>
  <v-container fluid>
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="name"
                :items="nameSel()"
                label="Όνομα"
                prepend-icon="mdi-car"
                clearable
              ></v-autocomplete>
            </v-col>
            
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="clientName"
                :items="clientNameSel()"
                label="Πελάτης"
                prepend-icon="mdi-account"
                clearable
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="2">
              <v-select
                v-model="completedStatus"
                :items="[{ text: 'Ολοκληρωμένο', value: true }, { text: 'Μη ολοκληρωμένο', value: false }]"
                label="Ολοκληρωμένο"
                prepend-icon="mdi-check-circle"
                clearable
              ></v-select>
            </v-col>

            <v-col cols="12" sm="2">
              <v-select
                v-model="correlated"
                :items="[{ text: 'Συσχετισμένο', value: 1 }, { text: 'Μη συσχετισμένο', value: 0 }]"
                label="Συσχετισμένο"
                prepend-icon="mdi-link"
                clearable
              ></v-select>
            </v-col>

            <v-col cols="12" sm="2">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="Ημερομηνίες"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filter_dates"
                @input="menu = false"
                range
                event-color="orange lighten-1"
                :events="functionEvents"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>

  <template>
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Εγγραφές</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      height=670
      :headers="headers"
      :items="clients"
      :search="search"
      sort-by="CreationDate"
      sort-desc
      item-key="DclId"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
      show-select
      @item-selected="itemSelected"
      @toggle-select-all="itemSelectAll"
      :footer-props="footerProps"

    >
<template v-slot:top>
      <v-toolbar
        flat
      >
        <v-spacer></v-spacer>
      </v-toolbar>
  </template>
     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click="showUpdates(item)"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
        <v-btn
          icon
          :to="{name: 'edit-repair',  params: {repairId: item.RepairId}}"
        >
         <v-icon>mdi-car-wrench</v-icon>
        </v-btn>
     </template>
     <template v-slot:item.Completed="{ item }">
      {{ item.Completed ? 'Ολοκληρωμένη' : 'Εκκρεμής' }}
    </template>
     <template v-slot:item.Correlated="{ item }">
      <template v-if="!item.Completed">
        -
      </template>
      <template v-else-if="item.Correlated === -1">
        ΑΝΕΥ
      </template>
      <template v-else-if="item.Correlated === 0">
        Μη συσχετισμένο
      </template>
      <template v-else-if="item.Correlated === 1 && item.Correlations && item.Correlations.length >= 1">
        <v-btn icon @click="showCorrelations(item)">
          <v-icon>mdi-file-document-outline</v-icon>
        </v-btn>
      </template>
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.Mark }}
      </td>
    </template>
        <template v-slot:foot="{ items }">
        {{  items.length }}
        </template>

    </v-data-table>
  </v-card>
</template>
  <v-snackbar
   timeout=2500
   v-model="snackbar"
   :multi-line=true>
      {{ snackText }}
  </v-snackbar>
<!-- Fullscreen Updates Dialog -->
<v-dialog v-model="showUpdatesDialog" width="50%" scrollable transition="dialog-bottom-transition">
  <v-card>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Ενημερώσεις</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="showUpdatesDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-expansion-panels class="pa-2" focusable>
    <v-expansion-panel
        v-for="update in selectedUpdates"
        :key="update.Id"
    >  
      <v-expansion-panel-header>
        <div>
          <div class="font-weight-bold">{{ update.Id }}</div>
          <div class="grey--text text--darken-1 text-caption">{{ update.ProvidedServiceCategory.Desc }}</div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div><strong>Περιγραφή:</strong> {{ update.InvoiceKind.Desc }}</div>
        <div v-if="update.comments"><strong>Λεπτομέρειες:</strong> {{ update.comments }}</div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
  </v-card-text>
  </v-card>
</v-dialog>
<v-dialog v-model="showCorrelationsDialog" max-width="500">
  <v-card>
    <v-card-title>
      <span class="headline">Συσχετίσεις Παραστατικών</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="showCorrelationsDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-list v-if="selectedCorrelations && selectedCorrelations.length">
        <v-list-item v-for="(corr, idx) in selectedCorrelations" :key="idx">
          <v-list-item-content>
            <v-list-item-title>
              {{ corr.Id }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ corr.Mark }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <div v-else class="grey--text">Δεν υπάρχουν συσχετίσεις.</div>
    </v-card-text>
  </v-card>
</v-dialog>
  </v-container>


</template>

<script>

String.prototype.format = function () {
  // store arguments in an array
  var args = arguments;
  // use replace to iterate over the string
  // select the match and check if related argument is present
  // if yes, replace the match with the argument
  return this.replace(/{([0-9]+)}/g, function (match, index) {
    // check if the argument is present
    return typeof args[index] == 'undefined' ? match : args[index];
  });
};


String.prototype.format = function( params ) {
  return this.replace(
    /\{(\w+)\}/g,
    function( a,b ) { return params[ b ]; }
  );
};

import { uniqBy as _uniqBy } from 'lodash';
import { clone as _clone } from 'lodash'

export default {
  components: {
  },
  props: {
    clients: {required: true, type: Array},
    loading: {default: true},
  },
  computed: {
      dateRangeText () {
        return this.filter_dates.join(' ~ ')
      },
  },
  data() {
    return {
      footerProps: {
        "items-per-page-options": [10,25,50,100, -1],
      },
      menu: false,
      expanded: [],
      toolmark: null,
      tocopy: {},
      dialog: false,
      balance: 0.0,
      afm: '',
      name: '',
      vehicle: [],
      filter_dates: [],
      search: '',
      snackbar: false,
      snackText: "",
      showUpdatesDialog: false,
      expandedUpdate: null,
      selectedUpdates: [],
      showCorrelationsDialog: false,
      selectedCorrelations: [],
      clientName: null,
      completedStatus: null,
      correlated: null,
      headers: [
          {
            text: 'A/A',
            align: 'start',
            //sortable: false,
            value: 'DclId',
            width: '10%',
          },
          { text: 'Αριθμός Κυκλοφορίας', value: 'VehicleRegNumber', width: '15%',
          filter: (value) => {
            if (!this.name) return true;
            return value == this.name;
            },
          },
          { text: 'Πελάτης', value: 'Client', width: '25%',
          filter: (value) => {
            if (!this.clientName) return true;
            return value == this.clientName;
            },
          },
          { text: 'Ημερομηνία Εισόδου', value: 'CreationDate', width: '10%',
            filter: (value) => {
              this.filter_dates.sort();
              if (this.filter_dates == 0) return true;
              if (this.filter_dates.length == 1) return value == this.filter_dates[0];
              if (this.filter_dates.length == 2) {
                return  this.checkDates(value);
              }
            },
          },
          { text: 'Ώρα Εισόδου', value: 'CreationTime', width: '10%' },
          { text: 'Ημερομηνία Εξόδου', value: 'CompletionDate', width: '10%',
            filter: (value) => {
              this.filter_dates.sort();
              if (this.filter_dates == 0) return true;
              if (this.filter_dates.length == 1) return value == this.filter_dates[0];
              if (this.filter_dates.length == 2) {
                return  this.checkDates(value);
              }
            },
          },
          { text: 'Ώρα Εξόδου', value: 'CompletionTime', width: '10%' },

          { text: 'Κατάσταση', value: 'Completed', align: 'center', groupable: false,
          filter: (value) => {
            if (this.completedStatus==null) return true;
            return value == this.completedStatus;
            },
          },
          { text: 'Στοιχεία Παραστατικού', value: 'Correlated', align: 'center', groupable: false,
          filter: (value) => {
            if (this.correlated==null) return true;
            return value == this.correlated;
            },
          },
          { text: 'Actions', value: 'actions', groupable: false },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async mounted() {
  
  },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  checkDates (date) {
    let d = new Date(date).getTime();
    let f = new Date(this.filter_dates[0]).getTime();
    let t = new Date(this.filter_dates[1]).getTime();
    console.log(d, f, t)
    if (d >= f && d <= t) return true;
    return false;
  },
  functionEvents (date) {
    return this.clients.some(e => e.CreationDate == date);
  },
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },
  showUpdates(item) {
    console.log(item)
    this.selectedUpdates = item.Updates || [];
    this.showUpdatesDialog = true;
    this.expandedUpdate = null; // reset expanded state
  },
  showCorrelations(item) {
    this.selectedCorrelations = item.Correlations || [];
    this.showCorrelationsDialog = true;
  },
  sumField(items, key) {
    // sum data in give key (property)
    return items.reduce((a, b) => a + (b[key] || 0), 0);
  },
  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },
  itemSelected(selected) {
    if (selected.value) {
      this.tocopy[selected.item.Mark] = this.parseItem(selected.item);
    } else {
      delete this.tocopy[selected.item.Mark];
    }
  },
  itemSelectAll(selected) {
    if (selected.value) {
      for (let item in selected.items) {
        this.tocopy[item.Mark] = item;
      }
    } else {
      this.tocopy = {}
    }
  },
  nameSel() {
    // Get unique client objects by VehicleRegNumber
    const uniqueClients = _uniqBy(this.clients, 'VehicleRegNumber');
    // Map to just the VehicleRegNumber values
    return uniqueClients.map(client => client.VehicleRegNumber).sort();
  },
  clientNameSel() {
    // Get unique client objects by VehicleRegNumber
    const uniqueClients = _uniqBy(this.clients, 'Client');
    // Map to just the VehicleRegNumber values
    return uniqueClients.map(client => client.Client).sort();
  },
  showTool(item) {
    return this.toolmark == item.Mark;
  },
  copyTimedOut() {
    this.toolmark = null;
  },
  parseItem(item) {
    let type = item.InvoiceType.Type;
    let name = item.Distributor.Name; //.split("||").pop();
    let data = {
        date: item.date,
        invoid: item.InvoiceId,
        type: type,
        name: name,
        mark: item.Mark,
        invotype: item.InvoiceType.Desc,
        num: '=COUNTIF(INDIRECT("E2:E"&(ROW()));"="&INDIRECT("E"&ROW()))',
    }
    if (type == '1.1') {
      data["net"] = item.netvalue;
      data["vat"] = item.vatvalue;
      data["total"] = item.totalvalue;
      data["typecode"] = 102;
    } else if (type == '2.1') {
      data["net"] = item.netvalue;
      data["vat"] = item.vatvalue;
      data["total"] = item.totalvalue;
      data["typecode"] = 108;
    } else {
      data["net"] = -item.netvalue;
      data["vat"] = -item.vatvalue;
      data["total"] = -item.totalvalue;
      data["typecode"] = 107;
    }
    let text ='"{name}"\t{invoid}\t{date}\t"Κανονικό"\t{typecode}\t"{invotype}"\tΤΔΑ\t{num}\t{net}\t{vat}\t{total}\t{mark}\n'.format(data)
    return text;
  },
  
    async createInvoice(item) {
        let invoice = _clone(this.invoiceForm);
        invoice.PaymTerm = item.PaymTerm.Term;
        invoice.NetValue = item.NetValue;
        invoice.VatValue = item.VatValue;
        invoice.TotalValue = item.TotalValue;
        invoice.SeriesCode = item.SeriesCode;
        invoice.DocNumber = item.DocNumber;
        invoice.InvoiceType = item.InvoiceType.Type;
        invoice.Date = item.Date;
        invoice.Mark = item.Mark;
        var response = await this.$api.post("/suppliers/"+item.Supplier.Id+"/invoice/", invoice);
        if (response.status == 201) {
          // this.invoiceForm.Id = response.data.Id;
          this.snackText = `Αντιγραφηκε το τιμολόγιο ${item.SeriesCode}-${item.DocNumber}.\nΝέο υπόλοιπο: ${response.data.Supplier.Balance.toFixed(2)}€`;
          this.snackbar = true;
          
        } else {
          alert(response.data);
        }
      },
  
  
  copyItems() {
    let text = "Προμηθετής\tΠαραστατικό\tΗμερ/νία\tΚατάσταση\tΚωδ. τύπου\tΤύπος παρ/κού\tΑιτιολογία\tΑριθμός\tΚαθαρή αξία\tΑξία ΦΠΑ\tΣύνολο Αξίας\tΑΑΔΕ ΜΑΡΚ\n";

    for (let k in this.tocopy) {
      text += this.tocopy[k];
    }
    navigator.clipboard.writeText(text);
        alert("Η γραμμή αντιγράφηκε στο πρόχειρο.");
  },
  copyToClip(item) {
    let header = "Προμηθετής\tΠαραστατικό\tΗμερ/νία\tΚατάσταση\tΚωδ. τύπου\tΤύπος παρ/κού\tΑιτιολογία\tΑριθμός\tΚαθαρή αξία\tΑξία ΦΠΑ\tΣύνολο Αξίας\tΑΑΔΕ ΜΑΡΚ\n";
    let text = header + this.parseItem(item);
    navigator.clipboard.writeText(text);
    this.toolmark = item.Mark;
    setTimeout(this.copyTimedOut, 1000);
  },

  }
}
</script>
